/**
 * @file contains Chat Localization Switcher
 * @param key
 * @param data
 * @param currentUser
 * @returns {string}
 */
export function chatLocalization(key: string, data, currentUser) {
  const userName =
    currentUser.userId === data.UDID
      ? currentUser?.temporaryNickname || currentUser?.nickname
      : data.UserName;

  if (key === '$$19157' || key === '!!FACTION_SYS_MES_JOINED') {
    return `${userName} has joined ${data.TargetAlliance}`;
  } else if (key === '$$19150' || key === '!!FACTION_SYS_MES_CREATED') {
    return ` ${data.TargetAlliance} Created.`;
  } else if (key === '$$19152' || key === '!!FACTION_SYS_MES_PROMOTED') {
    return `${userName} Promoted to ${data.role} by ${data.CustomData.by}`;
  } else if (key === '$$19153' || key === '!!FACTION_SYS_MES_DEOMOTED') {
    return `${userName} Demoted to ${data.role} by ${data.CustomData.by}`;
  } else if (key === '$$19151' || key === '!!FACTION_SYS_MES_LEVELUP') {
    return `${data.TargetAlliance} leveled up to ${data.faction_level}.`;
  } else if (key === '$$19154' || key === '!!FACTION_SYS_MES_ACCEPTED') {
    return `Join request from ${userName} has been accepted by ${data.CustomData.by}.`;
  } else if (key === '$$19155' || key === '!!FACTION_SYS_MES_REJECTED') {
    return `Join request from ${userName} has been rejected by ${data.CustomData.by}.`;
  } else if (key === '$$19156' || key === '!!FACTION_SYS_MES_KICKED') {
    return `${userName} has been kicked out by ${data.CustomData.by}.`;
  } else if (key === '$$19158' || key === '!!FACTION_SYS_MES_LEFT') {
    return `${userName} has left ${data.TargetAlliance}`;
  } else if (key === '$$19159' || key === '!!FACTION_SYS_MES_TRANSFER') {
    return `${data.CustomData.by} Transferred Leadership to ${userName}.`;
  }

  return key;
}
